import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {MessageContainer} from '../../components';
import FastModal from '../../components/FastModal';
import {getMessageBoxContent} from '../../components/MessageBox';
import {ModalSize} from '../../constants/dataEnum';
import withIntl from '../../lib/withIntl';
import './ModalRemoveUser.scss';

class ModalActiveUser extends Component {
  renderContent = () => {
    const {intl, activeNames, isExecutorUser} = this.props;

    const content = isExecutorUser
      ? intl.formatMessage({id: 'userManagement.modalActiveUser.contentExecutor'}, {name: activeNames.join(', ')})
      : intl.formatMessage(
          {id: 'userManagement.modalActiveUser.content'},
          {name: activeNames.join(', '), be: activeNames.length > 1 ? 'are' : 'is'},
        );

    return (
      <div className="ModalRemoveUser">
        {getMessageBoxContent(
          intl.formatMessage({id: 'userManagement.modalActiveUser.message'}),
          MessageContainer.MessageType.WARNING,
        )}
        <span>{content}</span>
      </div>
    );
  };

  render() {
    const {intl, showModal, onClose} = this.props;
    const confirmButton = intl.formatMessage({id: 'userManagement.modalActiveUser.confirmButton'});

    this.btnAction = [
      {
        text: confirmButton,
        style: 'primary',
        handlerClick: () => onClose(false),
      },
    ];

    return (
      <FastModal
        header={intl.formatMessage({id: 'userManagement.modalActiveUser.modalHeader'})}
        content={this.renderContent()}
        btnAction={this.btnAction}
        show={showModal}
        className="create-rename"
        isValid
        closeDisabled
        size={ModalSize.EXTRA_LARGE}
      />
    );
  }
}

ModalActiveUser.propTypes = {
  intl: PropTypes.any.isRequired,
  activeNames: PropTypes.array,
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  isExecutorUser: PropTypes.bool,
};

ModalActiveUser.defaultProps = {
  activeNames: [],
  showModal: false,
  onClose: () => {},
  isExecutorUser: false,
};

export default withIntl(ModalActiveUser);
